import { render, staticRenderFns } from "./WidgetCategory.vue?vue&type=template&id=354ab5ff&scoped=true"
import script from "./WidgetCategory.vue?vue&type=script&lang=js"
export * from "./WidgetCategory.vue?vue&type=script&lang=js"
import style0 from "./WidgetCategory.vue?vue&type=style&index=0&id=354ab5ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ab5ff",
  null
  
)

export default component.exports